<template>
    <AppCollapseItem
        ref="collapse"
        :controlled="true"
        :title="title"
        :is-visible="step.isOpen"
        :disabled="step.isDisabled"
        :class="stepClasses"
        @visible="handleVisibilityChange"
    >
        <WorkflowStepContent
            :context="context"
            :step="step"
            :review-contributions="reviewContributions"
            @validity-change="$emit('validity-change', $event)"
            @state-change="$emit('state-change', $event)"
            @schedule-step-save="$emit('schedule-step-save', $event)"
            @step-action="$emit('step-action', $event)"
            @execute-terminal-step="$emit('execute-terminal-step', $event)"
            @complete-external-step="$emit('complete-external-step', $event)"
            @effect="$emit('effect', $event)"
            @error="$emit('error', $event)"
            @complete-step="$emit('complete-step', $event)"
            @open-step="$emit('open-step', $event)"
        />
    </AppCollapseItem>
</template>

<script>
import AppCollapseItem from '@core/components/app-collapse/AppCollapseItem.vue'
import WorkflowStepContent from './WorkflowStepContent.vue'
import { resolveStepTitle } from './step-title'

export default {
    name: 'WorkflowStepHost',
    components: {
        AppCollapseItem,
        WorkflowStepContent,
    },
    props: {
        context: {
            type: Object,
            required: true,
        },
        step: {
            type: Object,
            required: true,
        },
        reviewContributions: {
            type: Array,
            default: () => [],
        },
    },
    computed: {
        title() {
            const baseTitle = resolveStepTitle(this.step, key => this.$t(key))

            return this.step.displayNumber === null
                ? baseTitle
                : `${this.step.displayNumber}. ${baseTitle}`
        },
        stepClasses() {
            return {
                done: this.step.isCompleted && (!this.step.hasValidationResult || this.step.isValid),
                'workflow-step--busy': this.step.isBusy,
                'workflow-step--loading': this.step.isLoading,
                'workflow-step--saving': this.step.isSaving,
                'workflow-step--stale': this.step.isStale,
            }
        },
    },
    methods: {
        handleVisibilityChange(isOpen) {
            this.$emit(isOpen ? 'open-step' : 'close-step', this.step.id)
        },
    },
}
</script>
